// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoBox_videoContainer__6Gp25","video":"VideoBox_video__+1W1E","overlayText":"VideoBox_overlayText__Y6K1z"};